import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { generativeAiStandardsRunHistory } from "./constants";
import type { GenerativeAiStandardsRunHistoryResult, GetGenerativeAiStandardsRunHistoryProps } from "./types";
import { isGenerativeAiStandardsRunHistoryResult } from "./validators";

/**
 * GET handler for the "/:app_group_id/generative_ai/standards_run_history" endpoint
 */
export const getGenerativeAiStandardsRunHistory = reactQueryFetcherAdapter(
  generativeAiStandardsRunHistory,
  (
    signal: AbortSignal,
    { appGroupId, startDate, endDate }: GetGenerativeAiStandardsRunHistoryProps
  ): Promise<GenerativeAiStandardsRunHistoryResult> => {
    return fetch(
      `/${appGroupId}/generative_ai/standards_run_history`,
      "GET",
      { start_date: startDate, end_date: endDate },
      { signal }
    );
  },
  isGenerativeAiStandardsRunHistoryResult
);
